import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CircleCrossFilledIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M8 0.833008C11.9579 0.833184 15.166 4.04304 15.166 8.00098C15.1656 11.9585 11.9576 15.1668 8 15.167C4.04234 15.1669 0.833447 11.9586 0.833008 8.00098C0.833008 4.04302 4.04207 0.83314 8 0.833008Z"
      fill="currentColor"
    />
    <path
      d="M10.4424 5.55762C10.1983 5.31354 9.80169 5.31354 9.55762 5.55762L8 7.11523L6.44238 5.55762C6.19831 5.31354 5.80169 5.31354 5.55762 5.55762C5.31354 5.80169 5.31354 6.19831 5.55762 6.44238L7.11523 8L5.55762 9.55762C5.31354 9.80169 5.31354 10.1983 5.55762 10.4424C5.8017 10.6864 6.19832 10.6864 6.44238 10.4424L8 8.88477L9.55762 10.4424C9.8017 10.6864 10.1983 10.6864 10.4424 10.4424C10.6864 10.1983 10.6864 9.8017 10.4424 9.55762L8.88477 8L10.4424 6.44238C10.6864 6.19832 10.6864 5.8017 10.4424 5.55762Z"
      fill="white"
    />
  </svg>
);
